import React from 'react';
import Compiler from '../compiler/Compiler';

const KovTitle = ({ item, color, compilerOptions, titleLevel = 1 }) => {
  const CustomTag = `h${titleLevel > 6 ? 6 : titleLevel}`;

  return (
    <CustomTag className="kov-title kov-content-block-title" style={{ color }}>
      <Compiler text={item.title} options={compilerOptions} />
    </CustomTag>
  );
};

export default KovTitle;
